import React from 'react';

// Grid size boxes for the placement panels, so the grid can grow or shrink without leaving the tracer.
function GridSizeInputs({ width, height, min = 1, max = 25, onResize, children }) {
  return (
    <div className="nn-row">
      Ruudukko
      <input type="number" className="nn-size" min={min} max={max} value={width} title="Ruudukon leveys" onChange={e => onResize(Number(e.target.value), height)} />
      ×
      <input type="number" className="nn-size" min={min} max={max} value={height} title="Ruudukon korkeus" onChange={e => onResize(width, Number(e.target.value))} />
      {children}
    </div>
  );
}

export default GridSizeInputs;
